import { useMemo } from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { columns2, columns3, columns4 } from '@lumapps/lumx/custom-icons';
import { useTranslate } from '@lumapps/translations';
import { useSlateStatic } from '@lumapps/wrex/slate';
import { TOOLBAR_ITEM_TYPE, ToolbarItem, type WrexEditor } from '@lumapps/wrex/types';

import { SCOPE } from '../../../constants';
import { WREX_COLUMNS } from '../../../keys';
import type { ColumnsEditor } from '../../../types';

const options: [number, string][] = [
    [2, columns2],
    [3, columns3],
    [4, columns4],
];

export const useColumnsButton = (otherProps?: any, scope?: string) => {
    const editorStatic = useSlateStatic() as WrexEditor<ColumnsEditor>;
    const { translateAndReplace, pluralize } = useTranslate();
    const { get } = useDataAttributes(scope || SCOPE);

    return useMemo((): ToolbarItem => {
        return {
            type: TOOLBAR_ITEM_TYPE.SUBMENU,
            label: translateAndReplace(pluralize(WREX_COLUMNS.OCCURRENCES_COLUMNS, 2), {
                NB: '',
            }),
            itemKey: 'Columns',
            icon: columns2,
            otherProps,
            childrenOptions: options.map(([number, icon]) => ({
                type: TOOLBAR_ITEM_TYPE.OPTION,
                itemKey: `${number}-columns`,
                icon,
                label: translateAndReplace(pluralize(WREX_COLUMNS.OCCURRENCES_COLUMNS, number), {
                    NB: number,
                }),
                onClick: () => {
                    editorStatic.insertColumns({ number });
                },
                otherProps: {
                    ...get({ element: 'option', action: `select-${number}-columns` }),
                },
            })),
        };
    }, [editorStatic, get, otherProps, pluralize, translateAndReplace]);
};
